export const CHECKOUT_URL = 'https://quimica-total-2026.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ieGHvAsPxj6dqqtFncB83j/Pack_Total_de_Quimica_Digital_2026.png'

export const PRODUCT_NAME = 'MEGA PACK QUÍMICA TOTAL 2026'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos, apuntes y explicaciones sobre átomos, tabla periódica, reacciones, fórmulas y cálculos, pero cada recurso enseña de manera diferente y terminas más confundido.',
  },
  {
    title: 'NO SABES QUÉ ESTUDIAR PRIMERO',
    desc: 'Estructura atómica, enlaces, balanceo, estequiometría, química orgánica, soluciones, pH... hay tantos temas que organizar el estudio parece complicado.',
  },
  {
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres comprender los conceptos, resolver ejercicios correctamente y aprobar tus evaluaciones, pero necesitas un camino que vaya desde los fundamentos hasta los problemas avanzados.',
  },
  {
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres aprender química, pero pasan las semanas y continúas buscando explicaciones, memorizando fórmulas sin entenderlas o dejando los ejercicios difíciles para después.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'QUÍMICA DESDE CERO: FUNDAMENTOS ESENCIALES',
    desc: 'Comprende qué es la materia, sus propiedades, estados, transformaciones, sustancias, mezclas, estructura atómica, elementos y fórmulas químicas mediante explicaciones y ejercicios prácticos.',
  },
  {
    title: 'TABLA PERIÓDICA, ESTRUCTURA ATÓMICA Y ENLACES QUÍMICOS',
    desc: 'Aprende modelos atómicos, configuración electrónica, propiedades periódicas, enlaces iónicos, covalentes y metálicos, estructuras de Lewis, geometría molecular y nomenclatura básica.',
  },
  {
    title: 'REACCIONES QUÍMICAS, ESTEQUIOMETRÍA Y CÁLCULOS',
    desc: 'Domina el balanceo de ecuaciones, el concepto de mol, masa molar, proporciones químicas, reactivo limitante, rendimiento, pureza, gases y reacciones de oxidación-reducción.',
  },
  {
    title: 'QUÍMICA ORGÁNICA E INORGÁNICA COMPLETA',
    desc: 'Comprende óxidos, ácidos, bases, sales, hidrocarburos, grupos funcionales, isomería, reacciones orgánicas, biomoléculas y polímeros con ejemplos organizados.',
  },
  {
    title: 'SOLUCIONES, CONCENTRACIÓN, pH Y FISICOQUÍMICA',
    desc: 'Aprende a calcular concentraciones, diluciones y pH, comprender ácidos y bases, interpretar el equilibrio químico y estudiar cinética, termoquímica y electroquímica.',
  },
  {
    title: 'QUÍMICA APLICADA, LABORATORIO Y RECURSOS PARA DOCENTES',
    desc: 'Relaciona la química con la vida cotidiana, conoce materiales y seguridad de laboratorio, interpreta mediciones, explora actividades educativas y aprende a organizar clases y evaluaciones.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '50 EJERCICIOS DE QUÍMICA RESUELTOS',
    desc: 'Una colección de 50 ejercicios progresivos con fórmulas, procedimientos y respuestas sobre estructura atómica, enlaces, reacciones, estequiometría, soluciones y fisicoquímica.',
    value: '$7.990',
  },
  {
    title: 'FORMULARIO QUÍMICO Y TABLAS DE CONSULTA RÁPIDA',
    desc: 'Una guía de fórmulas, conversiones, masas atómicas, tabla periódica, nomenclatura, cálculos, concentración, pH, gases y electroquímica para consultar cuando lo necesites.',
    value: '$5.990',
  },
  {
    title: 'SIMULACROS DE EXAMEN DE QUÍMICA CON RESPUESTAS',
    desc: 'Tres exámenes de nivel secundario, ingreso universitario y avanzado, con consignas, ejercicios, cálculos, solucionarios y criterios para evaluar tus conocimientos.',
    value: '$6.990',
  },
  {
    title: '20 FICHAS VISUALES Y MAPAS CONCEPTUALES',
    desc: '20 fichas de estudio y cinco mapas conceptuales para repasar átomos, tabla periódica, enlaces, reacciones, fórmulas, química orgánica y fisicoquímica de forma organizada.',
    value: '$8.990',
  },
  {
    title: 'KIT DOCENTE DE QUÍMICA: CLASES Y EVALUACIONES',
    desc: 'Planificaciones, clases desarrolladas, actividades imprimibles, ejercicios resueltos, rúbricas, evaluaciones y recursos adaptables para enseñar química y brindar apoyo escolar.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre apuntes y videos. Sigue una ruta desde los conceptos básicos hasta las fórmulas, reacciones, cálculos y contenidos avanzados.',
  },
  {
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende la tabla periódica, los enlaces, el balanceo, la estequiometría, la química orgánica, las soluciones y el pH con explicaciones y ejercicios organizados.',
  },
  {
    title: 'COMPRENDE LO QUE ESTÁS RESOLVIENDO',
    desc: 'Empieza a mirar una fórmula o un problema químico y reconocer qué datos necesitas, qué procedimiento aplicar y cómo comprobar si tu resultado tiene sentido.',
  },
  {
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden ayudarte a preparar exámenes, avanzar en tus estudios, organizar clases o fortalecer tu formación científica.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    label: 'TESTIMONIO 1 — ESTUDIANTE DE SECUNDARIA',
    quote:
      'Antes estudiaba las fórmulas de memoria y después no sabía cómo usarlas. Tener los temas ordenados y los ejercicios resueltos me ayudó a entender mejor cómo empezar cada problema. Antes de la prueba de mol y masa molar repasé con el formulario y los ejercicios del bono, y por primera vez terminé el examen sin quedarme en blanco.',
    author: 'Valentina Gómez',
    detail: '16 años · Córdoba, Argentina',
  },
  {
    label: 'TESTIMONIO 2 — INGRESANTE UNIVERSITARIO',
    quote:
      'Lo que más necesitaba era practicar cálculos. Poder repasar el mol, la masa molar, el balanceo y la estequiometría con ejemplos explicados me resultó muy útil para organizar el estudio. Seguí los tomos en orden, hice el simulacro de ingreso universitario y llegué al examen sabiendo qué tipo de problemas me iban a tomar.',
    author: 'Tomás Acosta',
    detail: '18 años · Rosario, Argentina',
  },
  {
    label: 'TESTIMONIO 3 — DOCENTE DE QUÍMICA',
    quote:
      'Buscaba material para preparar clases y actividades sin tener que reunir recursos de muchos lugares. Las fichas, las evaluaciones y el kit docente me dieron una base organizada. Ahora adapto las planificaciones a cada curso, imprimo las actividades y uso las rúbricas para corregir. Me ahorra varias horas de preparación cada semana.',
    author: 'Claudia Ferreyra',
    detail: '44 años · Mendoza, Argentina',
  },
  {
    label: 'TESTIMONIO 4 — ESTUDIANTE UNIVERSITARIO',
    quote:
      'Me costaba relacionar los conceptos con los ejercicios. Los simulacros me permitieron identificar qué temas necesitaba repasar antes de una evaluación. Después volvía al tomo de soluciones, pH y fisicoquímica, rehacía los ejemplos y practicaba hasta entender el procedimiento. Rendí el parcial de Química General mucho más tranquilo.',
    author: 'Martín Ruiz',
    detail: '20 años · La Plata, Argentina',
  },
  {
    label: 'TESTIMONIO 5 — PROFESOR PARTICULAR',
    quote:
      'Quería contar con ejercicios, explicaciones y material de consulta para mis alumnos. Tener los seis tomos y los bonos reunidos facilita mucho la preparación de las clases. Uso las fichas visuales para explicar la tabla periódica y los 50 ejercicios resueltos para practicar con cada alumno según su nivel.',
    author: 'Carolina Méndez',
    detail: '31 años · San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100 % digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza desde los fundamentos y avanza progresivamente hacia temas más complejos.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Materia, estructura atómica, tabla periódica, enlaces, reacciones, cálculos, química orgánica e inorgánica, soluciones, pH y química aplicada.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye ejemplos resueltos, actividades, evaluaciones y un bono especial con 50 ejercicios explicados.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los cinco bonos están incluidos sin costo adicional con la compra del pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas una sola vez, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material digital se entrega después de confirmarse el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo complementario y no reemplaza títulos, certificaciones ni requisitos profesionales.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes estudiar los tomos y utilizar los bonos según tus tiempos y necesidades.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Camila Fernández', city: 'Córdoba', minutes: 2 },
  { name: 'Lautaro Giménez', city: 'Rosario', minutes: 4 },
  { name: 'Martina López', city: 'Buenos Aires', minutes: 6 },
  { name: 'Prof. Silvia Castro', city: 'Mendoza', minutes: 9 },
  { name: 'Bautista Romero', city: 'La Plata', minutes: 13 },
  { name: 'Milagros Ojeda', city: 'Mar del Plata', minutes: 17 },
  { name: 'Facundo Vera', city: 'Salta', minutes: 22 },
  { name: 'Lucía Quiroga', city: 'San Miguel de Tucumán', minutes: 27 },
  { name: 'Prof. Daniel Ríos', city: 'Neuquén', minutes: 31 },
  { name: 'Abril Navarro', city: 'Santa Fe', minutes: 38 },
]
